import React from "react";
import CameraButton from "./CameraButton";
import LeaveRoomButton from "./LeaveRoomButton";
import MicButton from "./MicButton";
import SwitchToScreenSharingButton from "./SwitchToScreenSharingButton";
import { connect } from "react-redux";
import MenuButton from "./MenuButton";
import ChatButton from "./ChatButton";
import RecordButton from "./RecordButton";
import AlertText from "./AlertText";
import { useSearchParams } from "react-router-dom";

const VideoButtons = (props) => {
  const { connectOnlyWithAudio, isRoomHost, showError } = props;
  const [searchParams] = useSearchParams();
  const fromtime = searchParams.get("fromTime");
  return (
    <div className="video_buttons_container">
      {fromtime && (
        <p className="meeting-subject">Legal Consultation Session</p>
      )}
      <MicButton />
      <CameraButton connectOnlyWithAudio={connectOnlyWithAudio} />
      <LeaveRoomButton />
      {/* {!connectOnlyWithAudio && <SwitchToScreenSharingButton />} */}
      {/* <MenuButton /> */}
      <ChatButton />
      {/* {isRoomHost && <RecordButton />} */}
      {isRoomHost && showError && (
        <AlertText message="No participants joined the call." />
      )}
    </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStoreStateToProps)(VideoButtons);